import { useEffect, useRef } from "react";
import { useNotification } from "@context/NotificationContext";
import { useTranslation } from "react-i18next";

export function useErrorToast(failed: boolean, description: string): void {
  const { notify } = useNotification();
  const { t } = useTranslation();
  const latest = useRef({ notify, title: t("common.error"), description });
  latest.current = { notify, title: t("common.error"), description };

  useEffect(() => {
    if (failed) {
      const { notify: send, title, description: text } = latest.current;
      send({ type: "error", title, description: text });
    }
  }, [failed]);
}
